// constants
import { ResetPasswordActionTypes } from './constants';
import { ResetPassword as ResetPasswordData } from 'src/types/resetPassword';

export type ResetPasswordActionType = {
    type:
        | ResetPasswordActionTypes.API_RESPONSE_SUCCESS
        | ResetPasswordActionTypes.API_RESPONSE_ERROR
        | ResetPasswordActionTypes.EDIT_RESET_PASSWORD
        | ResetPasswordActionTypes.RESET
        | ResetPasswordActionTypes.RESET_SUCCESS
        | ResetPasswordActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const resetPasswordApiResponseSuccess = (
    actionType: string,
    data: ResetPasswordData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ResetPasswordActionType => ({
    type: ResetPasswordActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const resetPasswordApiResponseError = (
    actionType: string,
    data: ResetPasswordData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ResetPasswordActionType => ({
    type: ResetPasswordActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const editResetPassword = (params: any): ResetPasswordActionType => ({
    type: ResetPasswordActionTypes.EDIT_RESET_PASSWORD,
    payload: params,
});

export const resetResetPassword = (): ResetPasswordActionType => ({
    type: ResetPasswordActionTypes.RESET,
    payload: {},
});

export const resetResetPasswordSuccess = (): ResetPasswordActionType => ({
    type: ResetPasswordActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetResetPasswordError = (): ResetPasswordActionType => ({
    type: ResetPasswordActionTypes.RESET_ERROR,
    payload: {},
});
